import TransferPage from './TransferPage';

export default TransferPage;
